// extracted by mini-css-extract-plugin
export default {"placeholder":"XWVjFu9W","mobile":"mobile","content":"JSFo59Zr","emoji":"nwLf0Dzp"};